import React from 'react';
import PropTypes from 'prop-types';
import Media from './Media';
import MediaSkeleton, {
	MediaSkeletonContainerClasses
} from '../skeleton/MediaSkeleton';
import { useCompareOverImage } from '../../../hooks';

const MediaContainer = ({ shouldFullyRenderCard, vehicle, ...props }) => {
	const compareOverImage = useCompareOverImage();

	const shouldShowCompareOverImage =
		shouldFullyRenderCard && compareOverImage;

	const mediaContent = shouldFullyRenderCard ? (
		<Media
			{...props}
			vehicle={vehicle}
			shouldShowCompareOverImage={shouldShowCompareOverImage}
		/>
	) : (
		<MediaSkeleton />
	);

	return (
		<div
			className={`vehicle-card-media-container${
				!shouldFullyRenderCard
					? ` ${MediaSkeletonContainerClasses.join(' ')}`
					: ''
			}`}
		>
			{mediaContent}
		</div>
	);
};

MediaContainer.propTypes = {
	shouldFullyRenderCard: PropTypes.bool.isRequired,
	vehicle: PropTypes.shape({
		uuid: PropTypes.string
	})
};

export default MediaContainer;
